// FILE: components/ui/Skeleton.tsx
"use client";

interface SkeletonProps {
  className?: string;
  /** Nếu true, dùng màu trắng mờ cho nền tối (vd: balance card xanh đậm) */
  dark?: boolean;
  /** Stagger delay (ms) cho hiệu ứng sóng khi render list */
  delay?: number;
}

export function Skeleton({ className = "", dark = false, delay = 0 }: SkeletonProps) {
  const base = dark ? "bg-white/20" : "bg-slate-200/70";
  return (
    <div
      className={`animate-pulse rounded-md ${base} ${className}`}
      style={delay ? { animationDelay: `${delay}ms` } : undefined}
    />
  );
}

/** Skeleton cho 1 dòng giao dịch (dùng trong list lịch sử) */
export function SkeletonTxRow({ delay = 0 }: { delay?: number }) {
  return (
    <div className="flex items-center gap-3 px-5 py-3" style={{ animationDelay: `${delay}ms` }}>
      <Skeleton className="w-9 h-9 rounded-xl" delay={delay} />
      <div className="flex-1 space-y-1.5">
        <Skeleton className="h-3 w-32" delay={delay} />
        <Skeleton className="h-2 w-20" delay={delay} />
      </div>
      <Skeleton className="h-4 w-16" delay={delay} />
    </div>
  );
}

/** Skeleton cho 1 dòng bảng chiến hữu */
export function SkeletonRefRow({ delay = 0 }: { delay?: number }) {
  return (
    <tr>
      <td className="px-4 py-2.5"><Skeleton className="h-3 w-24" delay={delay} /></td>
      <td className="px-4 py-2.5"><Skeleton className="h-3 w-28" delay={delay} /></td>
      <td className="px-4 py-2.5"><Skeleton className="h-3 w-32" delay={delay} /></td>
      <td className="px-4 py-2.5"><Skeleton className="h-5 w-20 rounded-full" delay={delay} /></td>
      <td className="px-4 py-2.5 text-right"><Skeleton className="h-3 w-12 ml-auto" delay={delay} /></td>
    </tr>
  );
}